module.exports = "data:image/gif;base64,R0lGODlhHgAeALMAAMbZ6s3e7fj6/Nvn8urx9////9Ti7+3z+N7m99Tj797v9wAAAAAAAAAAAAAAAAAAACH5BAQUAP8ALAAAAAAeAB4AAARgEEhgjCKi6M27n6AUDJlncmFKEeepqsHRdu+blHNds7n+Dj2fKtES1gwuo82krAFpzRdvE63hCtUlNauSabiwLTjEG6eQWHMoow4B26BAGi4R0CeEu0ShByT6Bn2Cg4IRADs="


//////////////////
// WEBPACK FOOTER
// ./ramastangifs/topright.gif
// module id = 62
// module chunks = 4